<template>
    <v-flex x12 sm12 d-block class="card-dados card-dados__mobile">
        <h3 class="card-dados__titulo mb-0">Anexos</h3>
        <v-data-table :headers="this.filtrarColunas" :items="value" :total-items="value.length"
                      :loading="false" no-data-text="Não há arquivos adicionados" hide-actions
                      class="az-table-list table-arquivos-consulta">
            <template slot="items" slot-scope="props">
                <td>
                    {{ props.item.documentoId | documentoFilter(documentos) }}
                </td>
                <td>
                    {{ props.item.criadoEm | az-date(formatosDefault.DATA) }}
                </td>
                <td>
                    {{ props.item.nome }}
                </td>
                <td v-if="!ehPerfilFornecedor">
                    {{ props.item.situacao === 'ATIVO' ? 'Ativo' : props.item.situacao === 'INATIVO' ? 'Inativo' : 'Situação Desconhecida'}}
                </td>
                <td class="table-actions">
                    <botao-inativar-anexo class="actions-item" :situacaoAtual="props.item.situacao"
                                          v-if="deveMostrarBotaoInativarAnexo(props.item)"
                                          @inativarAnexo="$emit('atualizarSituacaoAnexo', props.item.id, 'INATIVO')"/>
                    <botao-ativar-anexo class="actions-item" :situacaoAtual="props.item.situacao"
                                        v-if="deveMostrarBotaoAtivarAnexo(props.item)"
                                        @ativarAnexo="$emit('atualizarSituacaoAnexo', props.item.id, 'ATIVO')"/>
                    <botao-download class="actions-item" v-if="props.item.uri || props.item.idVirtualizado"
                                    :documento="props.item"
                                    @baixarDocumentos="tratarEventDownloadAnexo($event, props.item)"/>
                </td>
            </template>
        </v-data-table>
    </v-flex>
</template>

<script>
import {mapState} from 'vuex'
import azAuth from '@azinformatica/loki/src/utils/az-auth'

export default {
    name: 'PainelAnexoVisualizacao',
    props: {
        value: {
            type: Array,
            required: true,
            default: () => {
                return []
            }
        },
        documentos: {
            type: Array,
            required: true,
            default: () => {
                return []
            }
        },
        situacaoCompraDireta: {
            type: String,
            default: 'ABERTA'
        }
    },
    data() {
        return {
            colunas: [
                {
                    value: 'tipo',
                    text: 'Tipo',
                    align: 'left',
                    sortable: true,
                    width: '80px',
                    class: 'primary--text'
                },
                {
                    value: 'data',
                    text: 'Data',
                    align: 'left',
                    sortable: true,
                    width: '50px',
                    class: 'primary--text'
                },
                {
                    value: 'nome',
                    text: 'Nome',
                    align: 'left',
                    sortable: true,
                    width: '200px',
                    class: 'primary--text'
                },
                {
                    text: 'Situação',
                    value: 'situacao',
                    sortable: true,
                    align: 'left',
                    width: '30px',
                    class: 'primary--text'
                },
                {
                    sortable: false,
                    align: 'center',
                    width: '30px',
                    text: 'Ações',
                    class: 'primary--text'
                }
            ]
        }
    },
    computed: {
        ...mapState(['loki']),
        ehPerfilFornecedor() {
            return this.$store.state.loki.user.type === 'EXTERNO'
        },
        filtrarColunas(){
            return !this.ehPerfilFornecedor? this.colunas:this.colunas.filter(coluna => coluna.value!=='situacao' )
        },
        exibirModoEdicao() {
            return (['EM_ANALISE', 'REANALISE', 'ABERTA', 'AGUARDANDO_ABERTURA'].includes(this.situacaoCompraDireta)
                && !this.ehPerfilFornecedor)
        },
        ehPerfilCompradorVisualizador(){
            return (this.$store.state.loki.user.authorities.length === 1 &&
                this.azAuth(this.$store.state.loki.user.authorities, ['Comprador.Consulta']))
        }
    },
    methods:{
        azAuth,
        tratarEventDownloadAnexo(tipoDownload, anexo){
            const payload = {
                tipoDownload: tipoDownload,
                anexo: anexo,
            }
            this.$emit('downloadAnexo', payload)
        },
        deveMostrarBotaoAtivarAnexo(anexo){
            return (this.exibirModoEdicao && anexo.documentoId
                && anexo.situacao === 'INATIVO' && !this.ehPerfilCompradorVisualizador)
        },
        deveMostrarBotaoInativarAnexo(anexo){
            return (this.exibirModoEdicao && anexo.documentoId
                && anexo.situacao === 'ATIVO' && !this.ehPerfilCompradorVisualizador)
        },

    },
    filters: {
        documentoFilter(docId, documentos) {
            const documentosEncontados = documentos.filter(doc => doc.id === docId)
            if (documentosEncontados.length > 0) {
                return documentosEncontados[0].nome
            }
            return ''
        }
    }
}
</script>

<style scoped lang="stylus">
    .table-arquivos-consulta
        padding 0 16px 16px

        tr:last-child
            border-bottom 0 !important

    .table-actions span
        display inline-block
        flex-wrap wrap

    @media (max-width 720px)
        .table-arquivos-consulta
            padding 0

            td:nth-of-type(1):before
                content "Tipo:"

            td:nth-of-type(2):before
                content "Data:"

            td:nth-of-type(3):before
                content "Nome:"

            td:nth-of-type(4):before
                content "Situação:"

            td:nth-of-type(5):before
                display none
</style>
